import React, { FC } from 'react'
import { RegionalPost } from '@store/slices/regionalPost.slice'
import { formatDateNicelyCzech } from '../../tools/time.tools'
import { useTheme } from '@config/theme.config'
import { Container } from 'react-bootstrap'

export const PostBox: FC<{ post: RegionalPost }> = ({ post }) => {
  const { theme } = useTheme()
  return (
    <Container
      className={`d-flex flex-row my-3 text-${theme === 'dark' ? 'light' : 'dark'}`}
    >
      <div
        className={'me-2'}
        style={{ maxWidth: '300px', minWidth: '300px', maxHeight: '210px' }}
      >
        {!!post.img && !!post.img.url && (
          <img
            style={{ maxWidth: '300px', maxHeight: '210px' }}
            src={post.img?.url}
            alt={`photo-post-${post.postId}`}
          />
        )}
      </div>
      <div className={'d-flex flex-column justify-content-between'}>
        <div className={'opacity-75'}>
          <span className={'fw-bold fs-6'}>
            {formatDateNicelyCzech(new Date(post.publishTime))}
          </span>
          <span className={'ms-2'}>{post.author}</span>
        </div>
        <div className={'my-3'}>
          <a
            className={`underline-on-hover text-decoration-none fw-bold fs-5 text-${theme === 'dark' ? 'light' : 'dark'}`}
            href={post.link}
            target="_blank"
            rel="noreferrer"
          >
            {post.title}
          </a>
          <br />
          <span>{post.description}</span>
        </div>
        <div className={'d-flex flex-row flex-wrap'}>
          {post.tags
            .filter((tag) => tag.postRelation !== 'author')
            .map((tag) => (
              <span
                className={'mx-1 flex-grow-0 text-nowrap opacity-50'}
                key={tag.id}
              >
                {tag.slug}
              </span>
            ))}
        </div>
      </div>
    </Container>
  )
}
